"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var userPermissions_1 = require("@/Hooks/userPermissions");
var AccessControl = function (_a) {
    var conditionalChildren = _a.conditionalChildren, requiredPermissions = _a.requiredPermissions, optionalPermissions = _a.optionalPermissions, children = _a.children, resourceId = _a.resourceId, resourceType = _a.resourceType, folderPermissions = _a.folderPermissions;
    var globalHasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var hasPermission = function (permission, resourceId, resourceType) {
        var globalPermissionCheck = globalHasPermission(permission, resourceId, resourceType);
        if (globalPermissionCheck)
            return true;
        if (folderPermissions && folderPermissions.length > 0) {
            if (Array.isArray(permission)) {
                return permission.some(function (permission) { return folderPermissions.includes(permission); });
            }
            else {
                return folderPermissions.includes(permission);
            }
        }
        return false;
    };
    var conditionalChildRendering = function (permissionAndChildren) {
        return permissionAndChildren.filter(function (value) {
            var resourceIdToCheck = value.resourceId !== undefined ? value.resourceId : resourceId;
            var resourceTypeToCheck = value.resourceType !== undefined ? value.resourceType : resourceType;
            if (typeof value.permission === "string") {
                return hasPermission(value.permission, resourceIdToCheck, resourceTypeToCheck);
            }
            return value.permission.some(function (permission) { return hasPermission(permission, resourceIdToCheck, resourceTypeToCheck); });
        })[0];
    };
    if (!requiredPermissions && !optionalPermissions && !conditionalChildren) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    var isAllowed = false;
    if (requiredPermissions) {
        if (typeof requiredPermissions === "string") {
            isAllowed = hasPermission(requiredPermissions, resourceId, resourceType);
        }
        else {
            isAllowed = requiredPermissions.every(function (permission) { return hasPermission(permission, resourceId, resourceType); });
        }
    }
    else if (optionalPermissions) {
        if (typeof optionalPermissions === "string") {
            isAllowed = hasPermission(optionalPermissions, resourceId, resourceType);
        }
        else {
            isAllowed = optionalPermissions.some(function (permission) { return hasPermission(permission, resourceId, resourceType); });
        }
    }
    else if (conditionalChildren) {
        var renderedChild = conditionalChildRendering(conditionalChildren);
        if (renderedChild) {
            return react_1.default.createElement(react_1.default.Fragment, null, renderedChild.children);
        }
        else {
            return null;
        }
    }
    if (!isAllowed) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = AccessControl;
